import { translate } from "../../Translations/translatorService";
import { validateFields } from "../statusChangeValidators";
import * as stagesTraffic from "../../Stages/StagesTraffic";
import { trafficRequiredFields } from "./trafficRequiredFields";
import { Traffic } from "../../../types/Products/TrafficLaw/Traffic/Traffic";

export const trafficValidators = {
  [stagesTraffic.STAGE_INCOMPLETE]: (traffic: Traffic) =>
    validateFields(trafficRequiredFields[stagesTraffic.STAGE_INCOMPLETE](traffic), traffic),
  [stagesTraffic.STAGE_READY]: (traffic: Traffic) =>
    validateFields(trafficRequiredFields[stagesTraffic.STAGE_READY](traffic), traffic),
  [stagesTraffic.STAGE_CHECKED]: (traffic: Traffic) =>
    validateFields(trafficRequiredFields[stagesTraffic.STAGE_CHECKED](traffic), traffic),
  [stagesTraffic.STAGE_AUTHORIZED]: (traffic: Traffic) =>
    validateFields(trafficRequiredFields[stagesTraffic.STAGE_AUTHORIZED](traffic), traffic),
  [stagesTraffic.STAGE_INSURANCE_COVERAGE_REQUEST]: (traffic: Traffic) =>
    validateFields(trafficRequiredFields[stagesTraffic.STAGE_INSURANCE_COVERAGE_REQUEST](traffic), traffic),
  [stagesTraffic.STAGE_ACCESS_TO_RECORDS]: (traffic: Traffic) =>
    validateFields(trafficRequiredFields[stagesTraffic.STAGE_ACCESS_TO_RECORDS](traffic), traffic),
  [stagesTraffic.STAGE_EXTRAJUDICIAL_PAID]: (traffic: Traffic) =>
    validateFields(trafficRequiredFields[stagesTraffic.STAGE_EXTRAJUDICIAL_PAID](traffic), traffic),
  [stagesTraffic.STAGE_OPINION_SUBMITTED]: (traffic: Traffic) =>
    validateFields(trafficRequiredFields[stagesTraffic.STAGE_OPINION_SUBMITTED](traffic), traffic),
  [stagesTraffic.STAGE_AUTHORITY_ANSWERED]: (traffic: Traffic) =>
    validateFields(trafficRequiredFields[stagesTraffic.STAGE_AUTHORITY_ANSWERED](traffic), traffic),
  [stagesTraffic.STAGE_TRIAL]: (traffic: Traffic) => {
    let errorMessages = validateFields(trafficRequiredFields[stagesTraffic.STAGE_TRIAL](traffic), traffic);
    if (traffic.appealRevoked !== null) {
      errorMessages.push(`“${translate("traffic.appealRevoked.label")}” darf nicht ausgefüllt sein.`);
    }
    if (traffic.trialWanted !== null && traffic.trialWanted !== "yes") {
      errorMessages.push(
        `“${translate("traffic.trialWanted.label")}” ist nicht “${translate("traffic.trialWanted.values.yes")}”.`
      );
    }
    if (traffic.authorityDecision !== "court") {
      errorMessages.push(
        `“${translate("traffic.authorityDecision.label")}” ist nicht “${translate(
          "traffic.authorityDecision.values.court"
        )}”.`
      );
    }
    return errorMessages;
  },
  [stagesTraffic.STAGE_TRIAL_DATE_SET]: (traffic: Traffic) => {
    let errorMessages = validateFields(trafficRequiredFields[stagesTraffic.STAGE_TRIAL_DATE_SET](traffic), traffic);
    if (traffic.courtNotice !== "trial") {
      errorMessages.push(
        `“${translate("traffic.courtNotice.label")}” ist nicht “${translate("traffic.courtNotice.values.trial")}”.`
      );
    }
    return errorMessages;
  },
  [stagesTraffic.STAGE_TRIAL_PAID]: (traffic: Traffic) =>
    validateFields(trafficRequiredFields[stagesTraffic.STAGE_TRIAL_PAID](traffic), traffic),
  [stagesTraffic.STAGE_DECISION_MADE]: (traffic: Traffic) => {
    if (traffic.processStoppedDate) {
      return [];
    }

    let errorMessages = validateFields(trafficRequiredFields[stagesTraffic.STAGE_DECISION_MADE](traffic), traffic);

    if (
      traffic.appealRevoked === null &&
      !traffic.courtDecisionDate &&
      !["revoked", "changed"].includes(traffic.authorityDecision ?? "") &&
      !["revoked", "no_trial"].includes(traffic.courtNotice ?? "")
    ) {
      errorMessages.push(
        `Eine der folgenden Optionen muss erfüllt sein: "${translate(
          "traffic.appealRevoked.label"
        )}" ist befüllt, "${translate("traffic.courtDecisionDate.label")}" ist befüllt, "${translate(
          "traffic.authorityDecision.label"
        )}" ist "${translate("traffic.authorityDecision.values.revoked")}" oder "${translate(
          "traffic.courtNotice.label"
        )}" ist "${translate("traffic.courtNotice.values.revoked")}" oder "${translate(
          "traffic.courtNotice.values.no_trial"
        )}"`
      );
    }
    return errorMessages;
  },
  [stagesTraffic.STAGE_COMPLETED]: (traffic: Traffic) =>
    validateFields(trafficRequiredFields[stagesTraffic.STAGE_COMPLETED](traffic), traffic),
};
